type Props = {
  deviceId: string;
  index: number;
  isCurrentDevice: boolean;
  isUnlinking: boolean;
  onUnlink: () => void;
};

export default function DeviceItem({
  deviceId,
  index,
  isCurrentDevice,
  isUnlinking,
  onUnlink,
}: Props) {
  return (
    <div className="flex flex-col items-center gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-0 text-base font-mono text-gray-700 bg-white px-3 sm:px-4 py-3 sm:py-4 rounded border border-gray-200">
      {/* Device ID */}
      <div className="flex flex-col items-center sm:flex-row sm:items-center gap-1 sm:gap-2">
        <span className="break-all sm:break-normal text-center sm:text-left">
          {index + 1}. {deviceId}
        </span>
        {isCurrentDevice && (
          <span className="text-green-600 font-semibold text-base whitespace-nowrap">
            (This device)
          </span>
        )}
      </div>

      {/* Unlink Button */}
      {!isCurrentDevice && (
        <button
          onClick={onUnlink}
          disabled={isUnlinking}
          className="px-3 sm:px-4 py-1.5 sm:py-2 text-xs bg-red-100 text-red-700 rounded hover:bg-red-200 disabled:bg-gray-200 disabled:text-gray-500 transition-colors font-medium whitespace-nowrap">
          {isUnlinking ? 'Unlinking...' : 'Unlink'}
        </button>
      )}
    </div>
  );
}

